import React from 'react';
import TransactionHistoryPresentational from './transaction-history-presentational';

const TransactionHistoryFunctional = () => {
	return <TransactionHistoryPresentational />;
};

export default TransactionHistoryFunctional;
